export default "__VITE_ASSET__BA4xRkc9__"